import myDetails from "../assets/myDetails.json";
import { useRef, useEffect, useState, useCallback } from 'react';

function PhotoSlideshow() {

    const [details, setDetails] = useState([]);
    useEffect(() => {
        setDetails(myDetails);
    }, []);

    const carouselRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const photos = details?.photos_taken || []; // safer reference

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((i) => (i + 1) % photos.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [photos.length]);

    useEffect(() => {
        if (carouselRef.current) {
            carouselRef.current.scrollTo({
                left: carouselRef.current.offsetWidth * currentIndex,
                behavior: 'smooth',
            });
        }
    }, [currentIndex]);

    const handlePrev = useCallback(() => {
        setCurrentIndex((i) => (i - 1 + photos.length) % photos.length);
    }, [photos.length]);

    const handleNext = useCallback(() => {
        setCurrentIndex((i) => (i + 1) % photos.length);
    }, [photos.length]);

    const handlePhotoClick = (index) => {
        setCurrentIndex(index);
        setIsFullscreen(true);
    };

    const closeFullscreen = useCallback(() => {
        setIsFullscreen(false);
    }, []);

    const handleKeyDown = useCallback((e) => {
        if (isFullscreen) {
            if (e.key === 'Escape') {
                closeFullscreen();
            } else if (e.key === 'ArrowLeft') {
                handlePrev();
            } else if (e.key === 'ArrowRight') {
                handleNext();
            }
        }
    }, [isFullscreen, handlePrev, handleNext, closeFullscreen]);

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [handleKeyDown]);

    return (
        <>
            <div className='carousel-wrapper'>
                <button className="carousel-button prev" onClick={handlePrev}>&lt;</button>
                <div className="carousel-container" ref={carouselRef}>
                    {details?.photos_taken?.map((photo, index) => (
                        <div className="carousel-slide" key={index}>
                            <img 
                                src={photo} 
                                alt='Slides' 
                                className="carousel-photo" 
                                onClick={() => handlePhotoClick(index)}
                                style={{ cursor: 'pointer' }}
                            />
                        </div>
                    ))}
                </div>
                <button className="carousel-button next" onClick={handleNext}>&gt;</button>
            </div>

            {isFullscreen && (
                <div className="fullscreen-overlay" onClick={closeFullscreen}>
                    <button 
                        className="fullscreen-close" 
                        onClick={closeFullscreen}
                    >
                        ✕
                    </button>
                    <button 
                        className="fullscreen-button prev" 
                        onClick={(e) => {
                            e.stopPropagation();
                            handlePrev();
                        }}
                    >
                        &lt;
                    </button>
                    <img 
                        src={photos[currentIndex]} 
                        alt="Fullscreen view" 
                        className="fullscreen-photo"
                        onClick={(e) => e.stopPropagation()}
                    />
                    <button 
                        className="fullscreen-button next" 
                        onClick={(e) => {
                            e.stopPropagation();
                            handleNext();
                        }}
                    >
                        &gt;
                    </button>
                </div>
            )}
        </>
    );
}

export default PhotoSlideshow;